module.exports = __webpack_public_path__ + "static/media/019.844df867.jpg";